import { Link, useLocation } from 'react-router';

import { UserRoundCog } from 'lucide-react';

import { Profile } from '../components/auth/LoggedInUser';

type NavRoute = {
  to: string;
  description: string;
  icon?: React.JSX.Element | string;
};

/**
 * Use to define the links for navigation in the app
 * https://reactrouter.com/en/6.24.1/components/link
 */
const ROUTES: Array<NavRoute> = [
  {
    to: '/',
    description: 'My Work Queue',
    icon: <UserRoundCog size={18} className="mr-2" />,
  },
  {
    to: '/search',
    description: 'Search',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mb-[2px] mr-1"
      >
        <path
          d="M8.64237 15.6427H5.11589C4.92883 15.6427 4.74944 15.5684 4.61717 15.4361C4.4849 15.3038 4.41059 15.1244 4.41059 14.9374V5.06324C4.41059 4.87619 4.4849 4.69679 4.61717 4.56453C4.74944 4.43226 4.92883 4.35795 5.11589 4.35795H8.64237V6.47384C8.64237 7.035 8.86529 7.57319 9.26209 7.96999C9.6589 8.3668 10.1971 8.58972 10.7583 8.58972H12.8741C12.8741 8.77678 12.9484 8.95617 13.0807 9.08844C13.213 9.22071 13.3924 9.29502 13.5794 9.29502C13.7665 9.29502 13.9459 9.22071 14.0782 9.08844C14.2104 8.95617 14.2847 8.77678 14.2847 8.58972V7.88443C14.2847 7.88443 14.2847 7.88443 14.2847 7.84211C14.2774 7.77732 14.2632 7.71348 14.2424 7.65168V7.5882C14.2085 7.51568 14.1633 7.44902 14.1084 7.39072L9.87663 3.15895C9.81833 3.10409 9.75167 3.05885 9.67915 3.02494C9.6581 3.02195 9.63673 3.02195 9.61567 3.02494L9.38998 2.94736H5.11589C4.55472 2.94736 4.01653 3.17028 3.61973 3.56709C3.22292 3.96389 3 4.50208 3 5.06324V14.9374C3 15.4986 3.22292 16.0367 3.61973 16.4335C4.01653 16.8303 4.55472 17.0533 5.11589 17.0533H8.64237C8.82942 17.0533 9.00882 16.979 9.14109 16.8467C9.27335 16.7144 9.34766 16.535 9.34766 16.348C9.34766 16.1609 9.27335 15.9815 9.14109 15.8493C9.00882 15.717 8.82942 15.6427 8.64237 15.6427ZM10.053 5.35242L11.8797 7.17913H10.7583C10.5712 7.17913 10.3918 7.10482 10.2595 6.97255C10.1273 6.84029 10.053 6.66089 10.053 6.47384V5.35242ZM6.52648 7.17913C6.33942 7.17913 6.16003 7.25344 6.02776 7.38571C5.89549 7.51798 5.82118 7.69737 5.82118 7.88443C5.82118 8.07148 5.89549 8.25088 6.02776 8.38315C6.16003 8.51541 6.33942 8.58972 6.52648 8.58972H7.23177C7.41883 8.58972 7.59823 8.51541 7.73049 8.38315C7.86276 8.25088 7.93707 8.07148 7.93707 7.88443C7.93707 7.69737 7.86276 7.51798 7.73049 7.38571C7.59823 7.25344 7.41883 7.17913 7.23177 7.17913H6.52648ZM16.1397 11.3122C16.0577 11.2459 15.962 11.1988 15.8594 11.1744C15.7569 11.15 15.6502 11.1489 15.5472 11.1711C15.2798 11.2275 15.0035 11.2271 14.7362 11.17C14.4689 11.1129 14.2166 11.0003 13.9956 10.8396C13.8748 10.7513 13.729 10.7038 13.5794 10.7038C13.4298 10.7038 13.2841 10.7513 13.1633 10.8396C12.942 10.9999 12.6897 11.1122 12.4225 11.1693C12.1553 11.2264 11.8791 11.227 11.6117 11.1711C11.5075 11.1487 11.3996 11.1502 11.2961 11.1755C11.1926 11.2007 11.0962 11.2491 11.0141 11.317C10.9319 11.3848 10.8663 11.4704 10.822 11.5673C10.7777 11.6642 10.7559 11.7699 10.7583 11.8764V13.5268C10.7572 14.0317 10.8739 14.5298 11.0992 14.9816C11.3245 15.4334 11.6521 15.8264 12.056 16.1293L13.1563 16.9122C13.2783 17.0038 13.4268 17.0533 13.5794 17.0533C13.732 17.0533 13.8805 17.0038 14.0026 16.9122L15.1029 16.0941C15.502 15.7947 15.8268 15.4074 16.0518 14.9621C16.2769 14.5169 16.3963 14.0257 16.4006 13.5268V11.8552C16.3999 11.7511 16.3762 11.6483 16.331 11.5544C16.2859 11.4605 16.2206 11.3778 16.1397 11.3122ZM14.99 13.5268C14.9934 13.8101 14.9315 14.0904 14.8092 14.346C14.6869 14.6016 14.5074 14.8257 14.2847 15.0009L13.5794 15.5087L12.8741 15.0009C12.6514 14.8257 12.472 14.6016 12.3497 14.346C12.2274 14.0904 12.1655 13.8101 12.1688 13.5268V12.624C12.6621 12.6018 13.1442 12.4693 13.5794 12.2361C14.0147 12.4693 14.4967 12.6018 14.99 12.624V13.5268ZM8.64237 12.8568H6.52648C6.33942 12.8568 6.16003 12.9311 6.02776 13.0633C5.89549 13.1956 5.82118 13.375 5.82118 13.5621C5.82118 13.7491 5.89549 13.9285 6.02776 14.0608C6.16003 14.193 6.33942 14.2674 6.52648 14.2674H8.64237C8.82942 14.2674 9.00882 14.193 9.14109 14.0608C9.27335 13.9285 9.34766 13.7491 9.34766 13.5621C9.34766 13.375 9.27335 13.1956 9.14109 13.0633C9.00882 12.9311 8.82942 12.8568 8.64237 12.8568ZM9.34766 10.0356H6.52648C6.33942 10.0356 6.16003 10.1099 6.02776 10.2422C5.89549 10.3744 5.82118 10.5538 5.82118 10.7409C5.82118 10.9279 5.89549 11.1073 6.02776 11.2396C6.16003 11.3719 6.33942 11.4462 6.52648 11.4462H9.34766C9.53472 11.4462 9.71411 11.3719 9.84638 11.2396C9.97865 11.1073 10.053 10.9279 10.053 10.7409C10.053 10.5538 9.97865 10.3744 9.84638 10.2422C9.71411 10.1099 9.53472 10.0356 9.34766 10.0356Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

ROUTES.push({
  to: '/print-queue',
  description: 'Print Queue',
  icon: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mb-[2px] mr-2"
    >
      <path
        d="M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
});

const Navigation = () => {
  const location = useLocation();

  const env = import.meta.env.VITE_SENTRY_ENV;

  const showBadge = !env?.startsWith('prod');

  const getBadgeClass = () => {
    if (env === 'staging') {
      return 'bg-yellow-700';
    }

    return 'bg-green-700';
  };

  return (
    <aside className="text-0 fixed inset-y-0 left-0 z-10 hidden w-[20vw] flex-col border-r bg-brand-dark-green sm:flex">
      <div className="flex min-h-[52px] items-center border-0 border-b border-b-[#ffffff19]">
        <Link to="/" key="Home" className="my-4 ml-[16px] flex">
          <img src="/assets/aspen_sm.svg" alt="Aspen logo" className="w-24" />
        </Link>
        {showBadge ? (
          <div
            className={`${getBadgeClass()} ml-16 rounded p-1 font-extrabold text-white`}
          >
            {import.meta.env.VITE_SENTRY_ENV}
          </div>
        ) : null}
      </div>
      <nav className="flex h-full flex-col overflow-auto sm:pt-5">
        <div className="flex h-full flex-col">
          <div className="px-2">
            {ROUTES.map(({ to, description, icon }) => (
              <Link
                key={description}
                to={to}
                className={`transition-300 group mb-1 flex items-center rounded-[8px] px-[6px] py-[12px] text-sm font-semibold text-brand-0 transition-all ${to === location.pathname ? 'bg-brand-0 text-brand-700' : 'hover:bg-[#1A4E4E]'} `}
              >
                {icon}
                {description}
              </Link>
            ))}
          </div>
        </div>
        <div className="mb-4 mt-auto flex">
          <Profile />
        </div>
        <div className="mb-4 mt-auto flex justify-center">
          <img
            src="/assets/powered_by_counterpart.png"
            alt="Powered by Counterpart"
            className="w-[64%]"
          />
        </div>
      </nav>
    </aside>
  );
};

export default Navigation;
